export var NODE_TYPE = {
  ASSESSMENT: 'ASSESSMENT',
  CHAPTER_ASSESSMENT: 'CHAPTER_ASSESSMENT',
  DECK: 'DECK',
  DIAGNOSTIC: 'DIAGNOSTIC',
  DYNAMIC: 'DYNAMIC',
  EXTRA_PRACTICE: 'EXTRA_PRACTICE',
  GENERAL: 'GENERAL',
  HIDDEN_BASIC: 'HIDDEN_BASIC',
  LEARNING: 'LEARNING',
  LEGACY: 'LEGACY',
  LEVEL2: 'LEVEL2',
  LEVEL3: 'LEVEL3',
  NOTE: 'NOTE',
  PPT_BASIC: 'PPT_BASIC',
  PPT_CONTENT: 'PPT_CONTENT',
  PPT_VIVA: 'PPT_VIVA',
  PRACTICE: 'PRACTICE',
  PUZZLE_EASY: 'PUZZLE_EASY',
  PUZZLE_HARD: 'PUZZLE_HARD',
  PUZZLE_MEDIUM: 'PUZZLE_MEDIUM',
  PUZZLE: 'PUZZLE',
  PYTHON_BASIC: 'PYTHON_BASIC',
  PYTHON_VISUAL: 'PYTHON_VISUAL',
  RECAP: 'RECAP',
  REMEDIAL: 'REMEDIAL',
  REVISION: 'REVISION',
  SIMULATION: 'SIMULATION',
  SUBJECTIVE: 'SUBJECTIVE',
  TEST_SERIES: 'TEST_SERIES',
  TEST: 'TEST',
  TURING_ASSESSMENT: 'TURING_ASSESSMENT',
  TURING_BASIC: 'TURING_BASIC',
  TURING_LINK: 'TURING_LINK',
  TURING_PRACTICE: 'TURING_PRACTICE',
  TURING_SHARE: 'TURING_SHARE',
  TURING_SUBJECTIVE: 'TURING_SUBJECTIVE',
  VIDEO: 'VIDEO'
};
export var WORKSHEET_TYPE = {
  TURING: 'TURING',
  PYTHON: 'PYTHON'
};
export var practiceNodeTypes = [NODE_TYPE.DIAGNOSTIC, NODE_TYPE.REMEDIAL, NODE_TYPE.LEARNING, NODE_TYPE.PRACTICE, NODE_TYPE.RECAP];
export var assessmentNodeTypes = [NODE_TYPE.ASSESSMENT, NODE_TYPE.CHAPTER_ASSESSMENT, NODE_TYPE.REVISION, NODE_TYPE.DYNAMIC];
export var subjectiveNodeTypes = [NODE_TYPE.SUBJECTIVE, NODE_TYPE.TURING_SUBJECTIVE];
export var turingNodeTypes = [NODE_TYPE.TURING_ASSESSMENT, NODE_TYPE.TURING_BASIC, NODE_TYPE.TURING_LINK, NODE_TYPE.TURING_PRACTICE, NODE_TYPE.TURING_SHARE, NODE_TYPE.TURING_SUBJECTIVE];
export var turingNonLearnosityNodeTypes = [NODE_TYPE.TURING_BASIC, NODE_TYPE.TURING_LINK, NODE_TYPE.TURING_SHARE];
export var pythonNodeTypes = [NODE_TYPE.PYTHON_BASIC, NODE_TYPE.PYTHON_VISUAL];
export var instructionNodeTypes = [].concat(turingNonLearnosityNodeTypes, pythonNodeTypes);
export var instructionWorksheetTypes = [WORKSHEET_TYPE.TURING, WORKSHEET_TYPE.PYTHON];
export var nodeLabels = {
  ASSESSMENT: 'ASSESSMENT',
  CHAPTER_ASSESSMENT: 'ASSESSMENT',
  DIAGNOSTIC: 'READINESS',
  EP_ADVANCED: 'ADVANCED',
  EP_LEARNING: 'LEARNING',
  EP_PRACTICE: 'PRACTICE',
  EP_TEST: 'ASSESSMENT',
  EXTRA_PRACTICE: 'EXTRA PRACTICE',
  LEARNING: 'LEARNING',
  LEVEL2: 'ADVANCED',
  LEVEL3: 'ADVANCED',
  PPT_BASIC: 'PRESENTATION',
  PPT_CONTENT: 'PRESENTATION',
  PPT_VIVA: 'PRESENTATION',
  PRACTICE: 'PRACTICE',
  PUZZLE: 'PUZZLE',
  PYTHON_BASIC: 'CODING ACTIVITY',
  PYTHON_VISUAL: 'CODING ACTIVITY',
  RECAP: 'RECAP',
  REMEDIAL: 'BRUSH UP',
  REVISION: 'REVISION',
  SUBJECTIVE: 'SUBJECTIVE',
  TEST_SERIES: 'TEST SERIES',
  TURING_ASSESSMENT: 'CODING ASSESSMENT',
  TURING_BASIC: 'CODING ACTIVITY',
  TURING_LINK: 'CODING ACTIVITY',
  TURING_PRACTICE: 'CODING PRACTICE',
  TURING_SHARE: 'CODING ACTIVITY',
  TURING_SUBJECTIVE: 'CODING SUBJECTIVE'
};
export var codingActivityNodes = ['PYTHON_BASIC', 'PYTHON_VISUAL', 'TURING_BASIC', 'TURING_LINK', 'TURING_SHARE'];
export var resumeNodeLabels = {
  PYTHON_BASIC: 'Resume',
  PYTHON_VISUAL: 'Resume'
};
export var pptNodeTypes = [NODE_TYPE.PPT_BASIC, NODE_TYPE.PPT_VIVA, NODE_TYPE.PPT_CONTENT];
export var SHEET_CODE = {
  FREE_ACCESS_EXPIRED: 'FREE_ACCESS_EXPIRED'
};
export var LEARNOSITY_QUESTIONS_API = 'https://questions-ie.learnosity.com/?v2022.1.LTS';
//# sourceMappingURL=sheet.js.map